// extracted by mini-css-extract-plugin
module.exports = {"adItemWrapper":"_2ivXleGbNVJMQsCpKv092w"};